import "./footer-style.scss";
const Footer = () => {
  return (
    <footer>
      <nav>
        <p>&copy; 2025 Hong Yelim. All rights reserved.</p>

        <address>
          <a href="mailto:hongggy@gmail.com">Email |</a>
          <a href="https://github.com/hongggyelim/hongggyelim">GitHub |</a>
          <a href="https://memoryelim.tistory.com/">Blog</a>
        </address>
      </nav>
    </footer>
  );
};

export default Footer;
